import { useState } from 'react';
import { Box, Button, Tab, Tabs, Typography } from '@mui/material';

import { ManageEmailTable } from '@/components/Admin/ManageEmail/ManageEmailTable';
import { AddEmailModal } from '@/components/ConfirmModals/AddEmailModal';

type EmailCategory =
  | 'all'
  | 'contract'
  | 'interest_rate'
  | 'system'
  | 'marketing'
  | 'shopping';

export const AdminEmail = () => {
  const [isAddEmailModalOpen, setIsAddEmailModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] =
    useState<EmailCategory>('all');

  const handleCategoryChange = (
    _event: React.SyntheticEvent,
    newValue: EmailCategory
  ) => {
    setSelectedCategory(newValue);
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          flexWrap: {
            xs: 'wrap',
            sm: 'nowrap',
          },
        }}
      >
        <Typography variant="h1">Manage Emails</Typography>
        <Button
          sx={{ width: { xs: '100%', sm: 'unset' } }}
          endIcon={<i className="fa-light fa-plus" />}
          onClick={() => setIsAddEmailModalOpen(true)}
        >
          Add Email
        </Button>
      </Box>
      <Box mt={3}>
        <Tabs
          value={selectedCategory}
          onChange={handleCategoryChange}
          sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
        >
          <Tab label="All" value="all" />
          <Tab label="Contract" value="contract" />
          <Tab label="Interest Rates" value="interest_rate" />
          <Tab label="System" value="system" />
          <Tab label="Marketing" value="marketing" />
          <Tab label="Shopping" value="shopping" />
        </Tabs>
        <ManageEmailTable
          category={selectedCategory === 'all' ? undefined : selectedCategory}
        />
      </Box>
      <AddEmailModal
        isOpen={isAddEmailModalOpen}
        onClose={() => setIsAddEmailModalOpen(false)}
      />
    </Box>
  );
};
